import React from 'react';
import { API_URL } from '../utils/api';

/**
 * The sign-in screen — the first thing anyone sees, so it carries the
 * cinematic dark treatment rather than the plain workspace.
 *
 * The old page wrapped itself in the app's Navbar and Footer, which exist to
 * carry a signed-in user's controls and a copyright line. Neither has a job
 * here: nobody is signed in yet. Sign-in itself is unchanged — the same
 * redirect to the same endpoint.
 */

const LoginPage = () => {
  const handleGoogleLogin = () => {
    window.location.href = `${API_URL}/api/auth/google/login`;
  };

  return (
    <div className="lm-ff lm-login" data-workspace-theme="dark">
      <div className="lm-login-inner">
        <img className="lm-login-logo" src="/brand/lm-logo.png" alt="Lien Machine"
             width="482" height="186" />

        <div className="lm-eyebrow">Liens department</div>
        <h1>Negotiate.<br />Reconcile.<br />Close out.</h1>
        <p className="lm-subtitle">
          Every medical lien on every case, from the first offer to the letter
          the client reads.
        </p>

        {/* The same panel every other surface in the app is built from. */}
        <section className="lm-panel">
          <h2>Sign in</h2>
          <p className="lm-note">Use your May Firm Google account to continue.</p>
          <button type="button" className="lm-button lm-primary lm-login-button"
                  onClick={handleGoogleLogin}>
            <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
            </svg>
            Continue with Google
          </button>
        </section>

        <div className="lm-login-foot">
          <small>A product of</small>
          <img src="/brand/mayfirm-full-color.png" alt="The May Firm Injury Lawyers"
               width="528" height="250" />
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
